import React, { useState } from "react";
import { Link } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa"; // Importing icons
import HeaderLogo from "../assests/images/Logo.svg";

const Header = ({ barHeight = 0 }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md fixed w-full z-[55]" style={{ top: barHeight }}>
      <div className="container mx-auto flex justify-between items-center py-3 px-4">
        <div className="w-14">
          <Link to="home" smooth={true} duration={500}>
            <img src={HeaderLogo} alt="Header Logo" className="w-full h-full" />
          </Link>
        </div>

        {/* Hamburger Menu (Mobile) */}
        <div className="lg:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-gray-800 text-2xl"
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Navigation - Responsive */}
        <nav
          className={`lg:flex lg:items-center lg:space-x-0 absolute lg:static top-16 left-0 w-full lg:w-auto bg-white lg:bg-transparent shadow-lg lg:shadow-none transition-all duration-300 ease-in-out z-[55] ${
            menuOpen ? "block" : "hidden"
          }`}
        >
          <ul className="flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-0 text-center py-4 lg:py-0">
            {[
              { label: "Home", to: "home" },
              { label: "About Us", to: "about-us" },
              { label: "Features", to: "features" },
              { label: "Download", to: "download" },
              { label: "Pricing", to: "pricing" },
              { label: "FAQs", to: "faqs" },
              { label: "Reviews", to: "reviews" },
              { label: "Contact", to: "contact" },
            ].map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  smooth={true}
                  duration={500}
                  className="text-gray-800 hover:text-[#30D5C8] cursor-pointer block px-6 py-2"
                  onClick={() => setMenuOpen(false)} // Close menu on click
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
